(ns app.front.view.admin.commands.add-execution-phase
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::add-work-phase
  (fn [_ [_ workspace-id]]
    {:comm/command {:command :admin/add-work-phase
                    :data    (util/mmap workspace-id)
                    :notify  {:success "Work phase added"}}}))

(defn view [match]
  (r/with-let [*workspace-id (r/atom "")]
    (let [tr (<sub [:tr])]
      [acommon/admin-page (util/mmap {:title "Add work phase to workspace"} match)
       [acommon/section {:title "Add work phase"}
        [ui/help
         (str "If a permit was issued while the workspace configuration was set not \"End process when permit is issued\", "
              "but this setting is later changed and the work phase needs to be enabled retroactively, that can be done "
              "here.")]
        [:div.flex.items-end
         [ui/text-input
          {:id          "workspace-id"
           :placeholder "CA-456456-B-123"
           :value       @*workspace-id
           :on-change   (comp (partial reset! *workspace-id)
                              str/trim
                              futil/tval)}]
         [:div.ml-4
          [ui/modal-confirmation-button
           (util/mmap {:on-yes-click        (fn [_]
                                              (>evt [::add-work-phase @*workspace-id])
                                              (reset! *workspace-id ""))
                       :trigger-button-opts {:size :field}
                       :trigger-button-text "Add work phase"}
                      tr)
           [:p "Add work phase to workspace " [:span.bold @*workspace-id]]]]]]])))

(def route
  {:name :view/admin.commands.add-workspace-execution-phase
   :view view})
